import { render, staticRenderFns } from "./waybill_order_page.vue?vue&type=template&id=3503847a&scoped=true"
import script from "./waybill_order_page.vue?vue&type=script&lang=js"
export * from "./waybill_order_page.vue?vue&type=script&lang=js"
import style0 from "./waybill_order_page.vue?vue&type=style&index=0&id=3503847a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3503847a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3503847a')) {
      api.createRecord('3503847a', component.options)
    } else {
      api.reload('3503847a', component.options)
    }
    module.hot.accept("./waybill_order_page.vue?vue&type=template&id=3503847a&scoped=true", function () {
      api.rerender('3503847a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/waybill/waybill_order_page.vue"
export default component.exports